import React, { useMemo } from "react"
import codImage from "src/assets/images/cod.png"
import credit from "src/assets/images/credit_card.png"
import onlineBanking from "src/assets/images/onlin-banking.png"
import paypal from "src/assets/images/paypal.png"
import { getWhiteLogoApp } from "src/utils/app-logo"
import { useTranslation } from "react-i18next"
import "./index.scss"

export default function LandingView() {
  const {t} = useTranslation()
  const paymentMethod = useMemo(() => {
    return [
      {
        image: codImage,
        name: t("payment-page.cod-name"),
        type: "COD",
      },
      {
        image: credit,
        name: "Stripe",
        type: "Stripe",
      },
      {
        image: onlineBanking,
        name: t("payment-page.online-name"),
        type: "Online",
      },
      {
        image: paypal,
        name: "Paypal",
        type: "Paypal",
      },
    ]
  }, [])
  return (
    <div  className="relative h-full md:h-screen w-full md:overflow-hidden">
      <div id="landingPage" className="flex h-full w-full flex-col pb-[24px] md:pb-[unset]">
        <a
          href={`${process.env.REACT_APP_HOME_DOMAIN_URL}`}
          className="flex h-6 items-center justify-start gap-1 px-6"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.56363 0.308679C8.17258 0.415893 7.96285 0.617056 7.67005 0.847682L2.01746 5.29983C1.63965 5.59743 1.38567 5.78214 1.15647 6.09598C0.975647 6.34357 0.841307 6.62356 0.759341 6.92014C0.655442 7.29606 0.666567 7.61229 0.666567 8.09703V14.2041C0.666567 15.1494 0.623229 15.7385 0.938372 16.365C1.17799 16.8413 1.56169 17.23 2.03211 17.4727C2.65074 17.7919 3.23243 17.7479 4.16583 17.7479H13.834C14.7674 17.7479 15.3491 17.7919 15.9678 17.4727C16.4381 17.23 16.8219 16.8414 17.0615 16.365C17.3767 15.7385 17.3333 15.1494 17.3333 14.2041V8.09703C17.3333 7.61226 17.3444 7.29599 17.2405 6.92014C17.1585 6.62357 17.0241 6.3451 16.8434 6.09762C16.8434 6.09708 16.8434 6.09653 16.8434 6.09598C16.6142 5.7821 16.3602 5.59743 15.9824 5.29983L10.3298 0.847682C10.037 0.617056 9.82732 0.415893 9.43625 0.308679C9.15101 0.23044 8.84889 0.23044 8.56363 0.308679ZM8.99982 1.93884C8.93211 1.92028 9.01471 1.94891 9.30743 2.1795L14.9584 6.63166C15.3362 6.92925 15.4607 7.04098 15.5036 7.09979C15.5639 7.18243 15.6081 7.27621 15.6354 7.37506C15.6549 7.44558 15.6664 7.61226 15.6664 8.09703V14.2041C15.6664 15.1494 15.6234 15.5028 15.5752 15.5985C15.4953 15.7573 15.3674 15.8869 15.2106 15.9678C15.1163 16.0164 14.7671 16.0601 13.8337 16.0601H4.16552C3.23212 16.0601 2.88296 16.0165 2.78862 15.9678C2.63183 15.8869 2.50398 15.7574 2.42404 15.5985C2.37588 15.5028 2.3329 15.1493 2.3329 14.2041V8.09703C2.3329 7.61226 2.34434 7.44553 2.36382 7.37506C2.39114 7.27621 2.43538 7.18231 2.49565 7.09979C2.53863 7.04094 2.66309 6.92926 3.04089 6.63166L8.69182 2.1795C8.98454 1.94891 9.06754 1.92029 8.99982 1.93884ZM5.66653 12.684C5.44552 12.684 5.23356 12.7729 5.07728 12.9312C4.921 13.0894 4.83321 13.3041 4.83321 13.5279C4.83321 13.7517 4.921 13.9664 5.07728 14.1247C5.23356 14.2829 5.44552 14.3719 5.66653 14.3719H12.3331C12.5541 14.3719 12.7661 14.2829 12.9224 14.1247C13.0786 13.9664 13.1664 13.7517 13.1664 13.5279C13.1664 13.3041 13.0786 13.0894 12.9224 12.9312C12.7661 12.7729 12.5541 12.684 12.3331 12.684H5.66653Z"
              fill="white"
            />
          </svg>
          <div className="text-14 font-semibold leading-5 text-white">
            {t("payment-page.back-home")}
          </div>
        </a>
        <div className="flex w-full flex-1 items-center justify-center">
          <div className="flex h-full w-[80%] items-center ">
            <div className="flex w-full flex-col gap-[40px] md:gap-[60px]">
              {/* Logo and name */}
              <div className="flex w-full flex-col gap-3">
                <div className="flex w-full gap-1">
                  <div className="flex items-center gap-6px">
                    <img src={getWhiteLogoApp()} alt="logo" className="h-5 w-5" />
                    <div className="left-4 text-24 font-bold text-white">
                      {process.env.REACT_APP_TITLE}
                    </div>
                  </div>
                  <div className="flex items-center text-18 leading-8 text-white">
                    {t("payment-page.payment-gateway")}
                  </div>
                </div>
                <div className="flex max-w-[796px] items-center">
                  <div className="line-clamp-2 text-[24px] leading-[30px] md:text-[72px] font-semibold md:leading-[90px] text-white">
                    {t("payment-page.payment-info")}
                  </div>
                </div>
              </div>
              {/* payment method */}
              <div className="flex flex-col md:flex-row w-full max-w-[796px] flex-wrap gap-[12px] md:gap-[27px]">
                {paymentMethod?.map((method, index) => (
                  <div key={index}>
                    <div className="flex w-full md:w-[240px] cursor-pointer items-center gap-4px rounded-3 border border-white px-1 py-1">
                      <img src={method.image} alt={method.name} />
                      <div className="text-14 font-medium leading-5 text-white">
                        {method.name}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
